<script>
import axios from 'axios';
import trans from '../mixins/trans';

export default {

    mixins: [
        trans
    ],

    props: [
        'route',
        'training',
        'trainingId',
        'trainingPrice',
        'as_voucher'
    ],

    methods: {
        addToBasket() {
          let data = new FormData();
          data.append('as_voucher', this.as_voucher);

            axios.post(this.route, data)
                .then((response) => {
                    window.app.$refs.miniCart.update();
                    window.app.$refs.miniCart.$refs.cart.update()
                    window.app.$refs.cartFlyout.show();

                    window.dataLayer.push({
                        'event': 'addToCart',
                        'training': this.training,
                        'trainingId': [parseFloat(this.trainingId)],
                        'trainingPrice': parseFloat(this.trainingPrice),
                        'source_of_request':'detail_page',
                        'as_voucher':this.as_voucher
                    });

                    /*
                    this.$notifications.success(this.__("The training ':training' was added to your basket.", {
                        'training': this.training
                    }), [
                        {
                            text: this.__('Basket'),
                            classes: 'btn btn-default',
                            callback: () => {
                                document.location.href = '/warenkorb';
                            }
                        }
                    ]);
                    */
                })
        }
    }
}
</script>